<template>
  <div :class="$style.filter_footers">
    <div
      v-if="footerType === 'footer-main' && (!blockFilterSave || showResetForHistoryOrExportOrShared)"
      :class="[$style.footer, $style.footer__main]"
    >
      <div :class="[$style.button, showResetForHistoryOrExportOrShared ? '' : $style.button__clear]">
        <vgp-button
          id="gp_autotest_filter_sidebar_clear_filter"
          data-testid="gp_autotest_filter_sidebar_clear_filter"
          :label="locales('filter_sidebar_clear_filter')"
          :type="'tertiary'"
          :disabled="!isActive"
          @onClick="$emit('onResetClick')"
        />
      </div>
      <div
        v-if="!showResetForHistoryOrExportOrShared"
        :class="[$style.button, $style.button__save, !pricingAccess ? 'pricing-tooltip' : '']"
        :style="{borderRadius: '4px !important'}"
        data-feature="saving_filters"
        data-position="left"
      >
        <vgp-button
          id="gp_autotest_filter_sidebar_save_filter"
          data-testid="gp_autotest_filter_sidebar_save_filter"
          :label="locales('filter_sidebar_save_filter')"
          :pricing-label="!pricingAccess ? locales(pricingPlan) : null"
          :type="'secondary'"
          :disabled="!isActive || !pricingAccess"
          @onClick="$emit('onSaveClick')"
        />
      </div>
    </div>
    <div
      v-if="footerType === 'footer-save'"
      :class="[$style.footer, $style.footer__saving]"
    >
      <div :class="[$style.button, $style.button__cancel]">
        <vgp-button
          id="gp_autotest_filter_sidebar_cancel_changes"
          data-testid="gp_autotest_filter_sidebar_cancel_changes"
          :label="locales('common_cancel')"
          :type="'tertiary'"
          :has-margin="false"
          @onClick="$emit('onCancelClick')"
        />
      </div>
      <div :class="[$style.button, $style.button__apply_save]">
        <vgp-button
          id="gp_autotest_filter_sidebar_apply_changes"
          data-testid="gp_autotest_filter_sidebar_apply_changes"
          :label="locales('common_save')"
          :type="'primary'"
          :has-margin="false"
          @onClick="$emit('onApplyClick')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import vgpButton from '$$uiKitComp/globalButton/vgpButton.vue';
import pricingHelpers, { getPlans } from '../../../helpers/pricingHelper';

export default {
  components: { vgpButton },
  props: {
    footerType: { type: String, required: false, default: 'filter-settings' },
    includeFooter: { type: Boolean, required: false, default: true },
    blockFilterSave: { type: Boolean, required: false, default: false },
    showResetForHistoryOrExportOrShared: { type: Boolean, required: false, default: false },
  },
  emits: {
    onSaveClick: null,
    onApplyClick: null,
    onCancelClick: null,
    onResetClick: null,
  },
  data() {
    return {
      locales: __,
    };
  },
  computed: {
    isActive() {
      return this.$store.getters['filter/isActive'];
    },
    pricingAccess() {
      return pricingHelpers.checkPricingAccess('saving_filters');
    },
    pricingPlan() {
      return `${getPlans('saving_filters')}`;
    },
  },
};
</script>

<style module lang='less'>
.filter_footers{
  .footer {
    padding: 12px;

    &__main {
      border-top: 1px solid #e5e5e5;

      .button {
        &__clear {
          margin-bottom: 12px;
        }

        &__save {
          width: 100%;
        }
      }
    }

    &__saving {
      display: flex;

      .button {
        &__cancel {
          margin-right: 10px;
          max-width: calc(100% / 2);
          width: 100%;
        }

        &__apply_save {
          // max-width: calc(100% / 2);
          width: 100%;
        }
      }
    }
  }
}
</style>
